import ProfileForm, { PROFILE_MODES } from '../profile-form';

const CreateSitePassProfile = () => <ProfileForm mode={PROFILE_MODES.SITEPASS} />;

export default CreateSitePassProfile;
